import { Button, Col, Form, Row } from "react-bootstrap";
import AirportDeparture from "./AirportDeparture ";
import AirportDestination from "./AirportDestination ";
import Carrier from "./Carrier";
import TimeArrival from "./TimeArrival";
import TimeDeparture from "./TimeDeparture";

import { RenderDateInput } from "app/common/renderInput";
import { MdDelete } from "react-icons/md";

const FlightLegs = ({
  index,
  values,
  touched,
  errors,
  handleChange,
  tripType,
  arrayHelpers,
  setFieldValue,
  array,
}) => {
  return (
    <>
      {index > 0 && <hr />}
      <Row
        style={{
          //  backgroundColor: "#e4ffff"  ,
          marginBottom: 8,
        }}
      >
        {index != 0 && (
          <Col>
            <div style={{ fontSize: 15, fontWeight: "bold" }}>
              Stops -{index}
            </div>
          </Col>
        )}
        {index > 0 && (
          <Col xs="6">
            {index == array.length - 1 && (
              <div className="d-flex justify-content-end ">
                <Button
                  variant="danger"
                  type="button"
                  onClick={() => {
                    arrayHelpers.remove(index);
                  }}
                >
                  <MdDelete color="white" size={20} />
                </Button>
              </div>
            )}
          </Col>
        )}
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Airlines <span className="text-danger">*</span>
            </Form.Label>

            <Carrier
              index={index}
              value={values?.flightLegs?.onward[index]?.airline || ""}
              onChange={handleChange}
              touched={touched?.flightLegs?.onward[index]?.airline}
              setFieldValue={setFieldValue}
            />

            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.airline &&
            errors?.flightLegs?.onward[index]?.airline ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.airline}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Flight Number <span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Flight Number"
              name={`flightLegs.onward[${index}].fN`}
              value={values?.flightLegs?.onward[index]?.fN || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched.flightLegs?.onward[index]?.fN &&
            errors?.flightLegs?.onward[index]?.fN ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.fN}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              PNR <span className="text-danger">*</span>
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="PNR"
              name={`flightLegs.onward[${index}].pnr`}
              value={values?.flightLegs?.onward[index]?.pnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.pnr &&
            errors?.flightLegs?.onward[index]?.pnr ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.pnr}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>GDS PNR</Form.Label>
            <input
              className="form-control"
              type="text"
              placeholder="GDS PNR"
              name={`flightLegs.onward[${index}].gdsPnr`}
              value={values.flightLegs.onward[index].gdsPnr || ""}
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.gdsPnr &&
            errors?.flightLegs?.onward[index]?.gdsPnr ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.gdsPnr}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Departure Airport <span className="text-danger">*</span>
            </Form.Label>
            <AirportDeparture index={index} setFieldValue={setFieldValue} />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.airportDepartureId &&
            errors?.flightLegs?.onward[index]?.airportDepartureId ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.airportDepartureId}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Arrival Airport <span className="text-danger">*</span>
            </Form.Label>

            <AirportDestination index={index} setFieldValue={setFieldValue} />

            {touched?.flightLegs?.onward &&
            touched.flightLegs.onward[index]?.airportDestinationId &&
            errors?.flightLegs?.onward &&
            errors.flightLegs.onward[index]?.airportDestinationId ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.airportDestinationId}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Departure Date <span className="text-danger">*</span>{" "}
            </Form.Label>
            <div
              style={{
                marginTop: -22,
                marginBottom: -10,
              }}
            >
              <RenderDateInput
                type="date"
                name={`flightLegs.onward[${index}].departureDate`}
                value={values?.flightLegs?.onward[index]?.departureDate || ""}
                onChange={handleChange}
              ></RenderDateInput>
            </div>

            {touched?.flightLegs?.onward &&
            touched.flightLegs.onward[index]?.departureDate &&
            errors?.flightLegs?.onward &&
            errors.flightLegs.onward[index]?.departureDate ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.departureDate}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Arrival Date <span className="text-danger">*</span>
            </Form.Label>
            <div
              style={{
                marginTop: -22,
                marginBottom: -10,
              }}
            >
              <RenderDateInput
                type="date"
                name={`flightLegs.onward[${index}].arrivalDate`}
                value={values?.flightLegs?.onward[index]?.arrivalDate || ""}
                onChange={handleChange}
              ></RenderDateInput>
            </div>
            {touched?.flightLegs?.onward &&
            touched.flightLegs.onward[index]?.arrivalDate &&
            errors?.flightLegs?.onward &&
            errors.flightLegs.onward[index]?.arrivalDate ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.arrivalDate}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Departure Time <span className="text-danger">*</span>
            </Form.Label>
            <TimeDeparture
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.departureTime &&
            errors?.flightLegs?.onward[index]?.departureTime ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.departureTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Arrival Time <span className="text-danger">*</span>
            </Form.Label>
            <TimeArrival
              index={index}
              values={values}
              handleChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.arrivalTime &&
            errors?.flightLegs?.onward[index]?.arrivalTime ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.arrivalTime}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Departure Terminal
              {/* <span className="text-danger">*</span> */}
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Departure Terminal"
              name={`flightLegs.onward[${index}].airportDepartureTerminal`}
              value={
                values?.flightLegs?.onward[index]?.airportDepartureTerminal ||
                ""
              }
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched.flightLegs?.onward[index]?.airportDepartureTerminal &&
            errors?.flightLegs?.onward[index]?.airportDepartureTerminal ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {
                  errors?.flightLegs?.onward[index]?.airportDepartureTerminal
                }{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              Arrival Terminal
              {/* <span className="text-danger">*</span> */}
            </Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Arrival Terminal"
              name={`flightLegs.onward[${index}].airportDestinationTerminal`}
              value={
                values?.flightLegs?.onward[index]?.airportDestinationTerminal ||
                ""
              }
              onChange={handleChange}
            />
            {touched?.flightLegs?.onward &&
            errors?.flightLegs?.onward &&
            touched?.flightLegs?.onward[index]?.airportDestinationTerminal &&
            errors?.flightLegs?.onward[index]?.airportDestinationTerminal ? (
              <div
                type="invalid"
                style={{
                  fontSize: "10px",
                  color: "red",
                }}
              >
                {errors?.flightLegs?.onward[index]?.airportDestinationTerminal}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default FlightLegs;
